import {
  deleteCurrentUserData,
  useMainStore,
} from "../../../core/store/mainStore";
import { auth } from "../../../firebaseConfig";

export const handleLogout = async () => {
  const state = useMainStore.getState();
  try {
    await auth.signOut();
    deleteCurrentUserData(state);
  } catch (error) {
    console.error("Error logging out:", error);
  }
};

export const useLogout = () => {
  const setLoggingOut = useMainStore((state) => state.setLoggingOut);
  return async () => {
    try {
      setLoggingOut(true);
      await handleLogout();
    } catch {
      // ignore logout errors
    } finally {
      setLoggingOut(false);
    }
  };
};
